var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"is-flex flex-column align-items-center"},[_c('span',{staticClass:"is-flex"},[_c('icon',{attrs:{"icon":"globe"}})],1),_c('small',[_vm._v("view app")])])}
var staticRenderFns = []

export { render, staticRenderFns }